<template>
    <div class="border-medium radius-normal  mb-3 bg-lighter">


        <div class="d-flex justify-content-between align-items-center px-3 py-2 border-bottom-light">

            <div class="font-weight-600 darker py-2 col-sm-6">
                <div class="row flexGrow1">
                    <label v-if="widget.editing">Name</label>
                    <input type="text" v-model="widget.name" class="w-100" v-if="widget.editing" placeholder="Widget Name"></input>
                    <span v-else>{{widget.name}}</span>
                </div>
            </div>


            <div class="d-flex" v-if="widget.loading">
                <loader></loader>
            </div>

            <div class="d-flex" v-if="!widget.loading">

                <div v-if="isCreatingWidget == false">
                    <span v-if="widget.editing" class="bg-color-3 lighter fs-smaller radius-normal py-1 px-2 pointer mr-2" @click="saveEditedWidget(widget)"><i class="ico ico-check fs-smaller"></i>Save</span>
                    <span v-if="widget.editing" class="bg-dark lighter fs-smaller radius-normal py-1 px-2 pointer mr-2" @click="cancelEditedWidget(widget)"><i class="ico ico-close fs-smaller"></i>Cancel</span>
                    <span v-if="!widget.editing" class="bg-dark lighter fs-smaller radius-normal py-1 px-2 pointer mr-2" @click="activateEditionMode(widget)">
                        <span v-if="widget.isLoading">
                            Loading
                        </span>
                        <span v-else>
                            <i class="ico ico-edit fs-smaller"></i>Edit
                        </span>
                    </span>
                    <span class="bg-color-6 lightest fs-smaller radius-normal py-1 px-2 pointer" @click="deletThisWidget(widget)"><i class="ico ico-delete fs-smaller"></i>Delete</span>
                </div>

                <div v-if="isCreatingWidget == true">
                    <span class="bg-color-3 lighter fs-smaller radius-normal py-1 px-2 pointer mr-2" @click="creatingSaveWidget(widget)" :class="{'opacity-50 notAllowed':validation.$invalid}"><i class="ico ico-check fs-smaller"></i>Save</span>
                    <span class="bg-dark lighter fs-smaller radius-normal py-1 px-2 pointer mr-2" @click="creatingWidgetCancelWidget(widget)"><i class="ico ico-close fs-smaller"></i>Cancel</span>
                </div>

            </div>

        </div>

        <!-- replaced with composer -->
        <div v-if="widget.editing && widget.categoryProductList" class="px-3 py-2">

            <div class="d-flex align-items-center">
                <div class="d-flex flex-grow-1">
                    <h3>Which options must be displayed in this booking engine?</h3>
                </div>
                <div class="d-flex">
                    <checkbox v-model="widget.isToActiveFutureItems"></checkbox>
                    <span>Allow new Products/Categories added to inventory to be automatically available in this widget.</span>
                </div>
            </div>
            <widget-composer v-model="widget" :productOptions="productsArr" :showInputName="false"></widget-composer>
        </div>


        <div v-if="isCreatingWidget == false">
            <div class="fs-small font-weight-600 dark d-flex align-items-center justify-content-between px-3 pt-3">
                <div>
                    <span>Preview and embed this code in your website.</span>
                </div>
                <div>
                    <span class="border-dark bg-lightest dark fs-smaller radius-normal py-1 px-2 pointer mr-2" @click="previewWidget(widget)">
                        <i class="far fa-eye fs-smaller"></i>Preview
                    </span>
                    <span class="dark border-dark radius-normal align-items-center px-2 py-1 pointer bg-lightest fs-smaller" @click="copyWidget(widget)">
                        <i class="ico ico-notes fs-smaller"></i>
                        Copy
                    </span>
                </div>
            </div>

            <div class="fs-small position-relative px-3 pb-3 pt-1">
                {{generateIframeCode(widget.guid)}}
            </div>
        </div>
    </div>
</template>

<script>
import extendedVSelect from '@/extends/vue-select'
import {mapGetters, mapActions} from 'vuex'
import Loader from '@/tools/loaders/loader1'
import WidgetComposer from '@/tools/widget/widgetComposer'

export default {
    data: function () {
        return {
            productsArr: [],
            allProducts: {
                name:'All Products',
                allProducts: true
            }
        }
    },
    props: {
        widget: {
            type: Object
        },
        validation: {
            type: Object
        },
        isCreatingWidget:{
            type: Boolean,
            default: false
        },
        productOptions: {
            type: Array
        }
    },
    created: function () {
        // creates a copy of all products just for this instance
        this.productsArr = JSON.parse(JSON.stringify(this.productOptions))

    },
    computed: {
        ...mapGetters([
            'account',
            'getWidgets'
        ]),
        treatedProducts: function () {
            let output = null
            //options for the dropdown
            output = JSON.parse(JSON.stringify(this.productOptions))
            output.unshift(this.allProducts)

            return output
        }
    },
    methods: {
        ...mapActions([
            'getAllWidgets',
            'createWidget',
            'deleteWidget',
            'updateWidget',
            'getSepcificWidget'
        ]),
        saveEditedWidget: function(widget) {
            this.$set(widget, 'loading', true)
            this.updateWidget(widget).then(response => {
                this.$emit('refreshWidgetList')
            })
        },
        cancelEditedWidget: function(widget) {
            widget.editing = false
        },
        creatingWidgetCancelWidget: function(widget) {
            this.$emit('creatingCancel')
        },
        creatingSaveWidget: function(widget) {
            if(this.validation.$invalid){
                return false
            }

            this.$emit('creatingSave')
        },
        activateEditionMode: function(widget) {
            if(widget.isLoading && widget.isLoading == true){
                return false
            }

            this.$set(widget, 'isLoading', true)

            this.getSepcificWidget(widget.id).then(downloadedWidget => {



                for (var objKey in widget) {
                    if (downloadedWidget.hasOwnProperty(objKey)) {
                        this.$set(widget, objKey, downloadedWidget[objKey])
                    }
                }

                this.$set(widget, 'isLoading', false)

                if(!widget.editing){
                    this.$set(widget, 'editing', true)
                }

            })

        },
        previewWidget: function (widget) {
            let url = process.env.WIDGET_URL+'/?guid='+widget.guid
            let win = window.open(url, '_blank');
            win.focus();
        },
        deletThisWidget: function(widget) {
            this.deleteWidget(widget).then(response => {
                this.$toasted.success(response.data);
                this.$emit('refreshWidgetList')
            })
        },
        copyWidget: function(widget) {
            let widgetIframe = this.generateIframeCode(widget.guid)
            this.$clipboard(widgetIframe)
            this.$toasted.success('Widget code copied');
        },
        generateIframeCode: function(guid) {
            return '<iframe src="'+process.env.WIDGET_URL+'/?guid='+guid+'" width="400" height="600" style="position: relative;display: block;margin: auto;border: none;width: 100%;max-width: 400px;height: 600px;"></iframe>'
        },
    },
    components:{
        vSelect: extendedVSelect,
        Loader,
        WidgetComposer
    }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// widgetEditor.vue?2c8ee425